// LaunchDarkly flag keys for Plan Service V2 migration
export const PLAN_FETCH_V2 = 'releaseBePlanFetchV2';
export const PLAN_FETCH_V2_BY_ORG = 'releaseBePlanFetchV2ByOrg';
export const PLAN_CREATE_V2 = 'releaseBePlanCreateV2';
export const PLAN_CREATE_V2_BY_ORG = 'releaseBePlanCreateV2ByOrg';
export const PLAN_UPDATE_V2 = 'releaseBePlanUpdateV2';
export const PLAN_UPDATE_V2_BY_ORG = 'releaseBePlanUpdateV2ByOrg';
export const PLAN_DELETE_V2 = 'releaseBePlanDeleteV2';
export const PLAN_DELETE_V2_BY_ORG = 'releaseBePlanDeleteV2ByOrg';
export const PLANS_LIST_V2 = 'releaseBePlansListV2';
export const PLANS_LIST_V2_BY_ORG = 'releaseBePlansListV2ByOrg';
export const PLAN_SUMMARIES_FETCH_V2 = 'releaseBePlanSummariesFetchV2';
export const PLAN_SUMMARIES_FETCH_V2_BY_ORG =
  'releaseBePlanSummariesFetchV2ByOrg';
